import { createFileRoute, Outlet } from '@tanstack/react-router';
import { LeftPanel } from '@mews-commander/onboarding';
import {
    Breadcrumbs,
    ModalWrapper,
    NewModalBodyWrapper,
    OptimusProvider,
    QueryBoundary,
    Tabs,
    useBreadcrumbs,
    useTabs,
} from '@mews-commander/ui';
import { MewsTeam, RouteType } from '@mews/enums';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { Stack, StackItem } from '@optimus-web/core';
import { useFeatureFlag } from '@mews/framework';
import { compactArray } from '@mews/fp';

/** Implements the design for the layout of the GoLiveAudits Page as
 * an adaptation of the PageHeader from @mews-commander/ui
 */
const Layout = () => {
    const { currentEnterpriseId } = Route.useParams();
    const breadcrumbs = useBreadcrumbs();
    const onboardingAuditLogEnabled = useFeatureFlag(FeatureFlag.onboardingAuditLogEnabled);

    const tabs = useTabs(
        '/$currentEnterpriseId/Settings/GoLiveAudits',
        compactArray(['Setup', 'Integrations', onboardingAuditLogEnabled ? 'ActivityLog' : null])
    );

    return (
        <ModalWrapper>
            <NewModalBodyWrapper padded>
                <Stack vertical spacing="150" tabletMax={{ spacing: '200' }}>
                    <StackItem>
                        <Stack spacing="200" itemAlignment="center" distribution="space-between">
                            <Breadcrumbs breadcrumbs={breadcrumbs} />
                        </Stack>
                    </StackItem>

                    <StackItem>
                        <Stack spacing="200" itemAlignment="start" distribution="space-between">
                            <LeftPanel enterpriseId={currentEnterpriseId} />
                            <Stack vertical fill spacing="50">
                                <Tabs>{tabs}</Tabs>
                                <QueryBoundary loader="inline" showError>
                                    <OptimusProvider density="spacious">
                                        <Outlet />
                                    </OptimusProvider>
                                </QueryBoundary>
                            </Stack>
                        </Stack>
                    </StackItem>
                </Stack>
            </NewModalBodyWrapper>
        </ModalWrapper>
    );
};

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/Settings/GoLiveAudits')({
    component: Layout,
    staticData: {
        title: TextKey.OnboardingSystemAudit,
        owner: MewsTeam.Connectivity,
        type: RouteType.Frontend,
    },
});
